export const TAB_TYPES = {
  OUR_PARTS: 'OUR_PARTS',
  SHARED_PARTS: 'SHARED_PARTS',
  ARCHIVED_PARTS: 'ARCHIVED_PARTS',
};

export const assemblyBadgeColor = '#334dfa';
